export default {
    REGISTER_MODAL: 'MODALS_REGISTER_MODAL',
    RETIRE_MODAL: 'MODALS_RETIRE_MODAL',
    DISPOSE: 'MODALS_DISPOSE',
};
